<template>
  <hm-content title="">
    <el-radio-group
      v-model="searchCondition.state"
      size="small"
      @change="switchTab"
    >
      <el-radio-button label="all"
        >全部({{ typeNumber.allNumber }})</el-radio-button
      >
      <el-radio-button label="0"
        >待审核({{ typeNumber.willNumber }})</el-radio-button
      >
      <el-radio-button label="1"
        >已同意({{ typeNumber.passNumber }})</el-radio-button
      >
      <el-radio-button label="2"
        >已驳回({{ typeNumber.returnNumber }})</el-radio-button
      >
    </el-radio-group>
    <div class="table-panel flex flex-end mt10">
      <div>
        <el-input
          clearable
          style="width:200px"
          v-model.trim="searchCondition.queryKey"
          placeholder="请输入会员手机号/导购工号"
          size="small"
          class="ipt mr10"
        ></el-input>

        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output('queryAllList', '导购营销报表')"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="mobilePhone"
          label="会员手机号"
        >
          <template slot-scope="scope">
            <div class="blue">
              {{ scope.row.mobilePhone }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="userName"
          label="客户姓名"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createBy"
          label="申请导购"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="workNum"
          label="导购工号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="departName"
          label="导购机构"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="申请日期"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="marketingReason"
          label="审核原因"
        >
          <template slot-scope="scope">
            <div class="blue">
              {{ scope.row.marketingReason }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="state"
          label="状态"
        >
          <template slot-scope="scope">
            <div class="blue" v-if="scope.row.state === '0'">
              待审核
            </div>
            <div class="success" v-if="scope.row.state === '1'">
              同意
            </div>
            <div class="danger" v-if="scope.row.state === '2'">
              驳回
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="updateBy"
          label="审核人"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="updateTime"
          label="审核时间"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                size="small"
                type="text"
                @click="details(scope.row)"
                :disabled="scope.row.state !== '0'"
                >审核</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="审核"
      :close-on-click-modal="false"
      @close="dialogVisible = false"
      :visible.sync="dialogVisible"
    >
      <div>
        <ul class="dialog">
          <li class="flex flex-wrap">
            <div class="dialog-tit flex flex-end">
              营销会员:
            </div>
            <div style="color:#222222">
              {{ row.userName }}/{{ row.mobilePhone }}
            </div>
          </li>
          <li class="flex flex-wrap">
            <div class="dialog-tit flex flex-end">
              营销原因:
            </div>
            <div style="color:#222222">
              {{ row.marketingReason }}
            </div>
          </li>
          <li class="flex flex-wrap">
            <div class="dialog-tit flex flex-end">
              备注说明:
            </div>
            <div style="color:#222222">
              {{ row.remark }}
            </div>
          </li>
          <li class="flex flex-wrap">
            <div class="dialog-tit flex flex-end">
              申请人:
            </div>
            <div style="color:#222222">
              {{ row.departName }} {{ row.createBy }}/{{ row.workNum }}
            </div>
          </li>
          <li class="flex flex-wrap">
            <div class="dialog-tit flex flex-end">
              申请时间:
            </div>
            <div style="color:#222222">
              {{ row.createTime }}
            </div>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="tongguo" size="small" type="success"
          >审核通过</el-button
        >
        <el-button @click="detailsVisible = true" type="primary" size="small"
          >审核驳回</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="选择券包"
      :visible="passVisible"
      @close="passVisible = false"
      custom-class="sales-volumn-dialog"
    >
      <el-form
        label-width="80px"
        :model="ruleFormPass"
        :rules="rulesPass"
        ref="ruleFormPass"
      >
        <el-form-item label="选择券包" prop="sendId">
          <el-select
            clearable
            v-model="ruleFormPass.sendId"
            placeholder="选择券包"
            size="small"
            filterable
            class="mr10"
          >
            <el-option
              v-for="(item, i) in couponSendList"
              :key="i"
              :label="item.name"
              :value="item.couponSendId"
            ></el-option>
          </el-select>
          <div class="form-tip">
            请先在优惠券发放中设置发放类型为“活动发放"的优事券包，方可直接给用户发放优惠券包
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="pass('ruleFormPass')" size="small" type="success"
          >确认发放</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="驳回原因"
      :visible="detailsVisible"
      @close="detailsVisible = false"
      custom-class="sales-volumn-dialog"
    >
      <el-form
        label-width="80px"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item label="驳回原因" prop="rejectionReason">
          <el-input
            maxlength="100"
            placeholder="请输入驳回原因"
            size="small"
            style="width: auto"
            :autosize="{ minRows: 4 }"
            type="textarea"
            v-model="ruleForm.rejectionReason"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submitReject('ruleForm')" size="small" type="primary"
          >确认驳回</el-button
        >
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      searchCondition: {
        state: "all"
      },
      ruleForm: {
        rejectionReason: ""
      },
      rules: {
        rejectionReason: {
          required: true,
          message: "请输入驳回原因",
          trigger: "change"
        }
      },
      ruleFormPass: {
        sendId: ""
      },
      rulesPass: {
        sendId: {
          required: true,
          message: "请选择卷包",
          trigger: "change"
        }
      },
      dialogVisible: false,
      passVisible: false,
      detailsVisible: false,
      isOutputing: false,
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      typeNumber: {},
      row: {},
      couponSendList: []
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.state =
        searchCondition.state === "all" ? "" : searchCondition.state;
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryGuiderMarketList",
        params
      );
      const { list, typeNumber } = result;
      this.typeNumber = typeNumber;
      this.list = list.records;
      this.total = list.total;
    },
    queryAllList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.state =
        searchCondition.state === "all" ? "" : searchCondition.state;
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryAllGuiderMarketList", params);
    },
    tongguo() {
      this.passVisible = true;

      this.queryCouponList();
    },
    async queryCouponList() {
      let params = {
        storeCode: this.row.storeCode
      };

      const { result } = await this.$store.dispatch(
        "findCouponSendList",
        params
      );
      this.couponSendList = result;
    },
    switchTab() {
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    details(row) {
      this.dialogVisible = true;
      this.row = row;
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
    },
    resetFormPass() {
      this.$refs.ruleFormPass.resetFields();
    },
    async submitReject(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        const params = JSON.parse(JSON.stringify(this.ruleForm));
        params.id = this.row.id;
        params.state = "2";
        this.$store.dispatch("updateMarketCheck", params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            setTimeout(() => {
              this.resetRuleForm();
            }, 0);
            this.dialogVisible = false;
            this.detailsVisible = false;
            this.queryList();
          }
        });
      } else {
        return false;
      }
    },
    async pass(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        const params = JSON.parse(JSON.stringify(this.row));

        Object.assign(params, this.ruleFormPass);
        params.state = "1";

        this.$store.dispatch("updateMarketCheck", params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            setTimeout(() => {
              this.resetFormPass();
            }, 0);
            this.dialogVisible = false;
            this.passVisible = false;
            this.queryList();
          }
        });
      } else {
        return false;
      }
    },
    // 导出excel
    output(funcName, title) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        const func = this[funcName];
        func()
          .then(res => {
            const list = res.result.list.records;
            list.forEach(v => {
              if (v.state === "0") {
                v.state = "待审核";
              } else if (v.state === "1") {
                v.state = "同意";
              } else if (v.state === "2") {
                v.state = "驳回";
              }
            });
            const tHeader = this.$refs.table.columns
              .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter(o => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog {
  li {
    margin: 15px;
  }

  .dialog-tit {
    width: 80px;
    margin-right: 5px;
    color: #999999;
  }
}
</style>
